import { GameStateManager } from './StateManager';
import { SpecialEffect, GameState } from './types';

/**
 * Player类
 * 负责管理玩家状态和数据
 */
export class Player {
  private stateManager: GameStateManager;

  /**
   * 构造函数
   * @param stateManager 游戏状态管理器
   */
  constructor(stateManager: GameStateManager) {
    this.stateManager = stateManager;
  }

  /**
   * 更新时间
   * @param timeChange 时间变化值(分钟)
   */
  updateTime(timeChange: number): void {
    this.stateManager.updateTime(timeChange);
  }

  /**
   * 更新距离
   * @param distanceChange 距离变化值(公里)
   */
  updateDistance(distanceChange: number): void {
    this.stateManager.updateDistance(distanceChange);
  }

  /**
   * 添加特殊效果
   * @param effect 特殊效果
   */
  addSpecialEffect(effect: SpecialEffect): void {
    this.stateManager.addSpecialEffect(effect);
  }

  /**
   * 获取玩家状态
   * @returns 当前游戏状态
   */
  getState(): GameState {
    return this.stateManager.getState();
  }
} 